import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import anime from 'animejs/lib/anime.es.js';
import { SpinnerComponent } from '../../loaders/spinner/spinner.component';

@Component({
  selector: 'app-primary-btn',
  standalone: true,
  imports: [CommonModule, SpinnerComponent],
  templateUrl: './primary-btn.component.html',
  styleUrl: './primary-btn.component.scss'
})
export class PrimaryBtnComponent {
  @ViewChild('btnContainer') btnContainer!: ElementRef;
  @Input() animated: boolean = false;
  @Input() mb: string = "0px";
  @Input() mt: string = "0px";
  @Input() disabled: boolean = false;
  @Input() gradient: boolean = false;
  @Input() isLoading: boolean = false;
  @Input() variant: string = null;

  btnInitialized: boolean = false;
  isAnimating: boolean = false;

  private animationTimeline: anime.AnimeTimelineInstance | null = null;
  private animationTimeout: any = null;

  // ngOnInit() {
  //   this.initAnimation();
  // }

  getRandomDelay() {
    const randomDelay = Math.floor(Math.random() * (800 - 1200 + 1)) + 1200;
    return randomDelay;
  }

  ngAfterViewInit() {
    this.btnInitialized = true;
    this.isAnimating = this.animated;

    setTimeout(() => {
      this.initAnimation();
    }, this.getRandomDelay())
  }

  private initAnimation(): void {
    if (!this.btnContainer || !this.btnContainer.nativeElement) {
      console.error('btnContainer is not available.');
      return;
    }
    const containerWidth = this.btnContainer.nativeElement.offsetWidth;
    const containerHeight = this.btnContainer.nativeElement.offsetHeight;
    const ballElement = document.querySelector('.btn-ball') as HTMLElement | null;

    if (!this.isAnimating || !ballElement) return;

    anime.remove('.btn-ball');
    ballElement.classList.add('active');

    this.animationTimeline = anime.timeline({
      targets: '.btn-ball',
      easing: 'easeInOutSine',
      autoplay: true,
      update: (anim) => {
        const targets = anim.animatables[0].target as HTMLElement;
        const offset = (anim.currentTime % 4000) / 4000;
        const shadowLength = 64 * offset;
        targets.style.boxShadow = `0 0 ${shadowLength}px rgb(255 245 190 / 70%)`;
      },
      complete: () => {
        ballElement.classList.remove('active');
        // setTimeout(() => {
        //   ballElement.classList.add('active');
        //   this.animationTimeline.play();
        // }, this.getRandomDelay());
      }
    });

    // 🟢 No need to pass targets again in each step
    this.animationTimeline
      .add({ translateY: -6, duration: 10 })
      .add({ translateX: containerWidth - 6, duration: 600 })
      .add({ translateY: containerHeight -2, duration: 300 })
      .add({ translateX: -4, duration: 600 })
      .add({ translateY: 0, duration: 300 });
  }


  private stopAnimation(): void {
    this.isAnimating = false;

    // Cancel loop timeout
    if (this.animationTimeout) {
      clearTimeout(this.animationTimeout);
      this.animationTimeout = null;
    }

    // Stop timeline
    if (this.animationTimeline) {
      this.animationTimeline.pause();
      this.animationTimeline.seek(0); // Reset to beginning
      this.animationTimeline = null;
    }

    // Cleanup the ball
    const ballElement = document.querySelector('.btn-ball') as HTMLElement | null;
    if (ballElement) {
      ballElement.classList.remove('active');
      ballElement.style.boxShadow = 'none';
      ballElement.style.transform = 'translate(0px, 0px)';
    }

    anime.remove('.btn-ball');
  }

  ngOnDestroy() {
    this.stopAnimation();
    anime.remove('.btn-ball');
  }

}
